import { render, staticRenderFns } from "./TrocadeSenhaLogin.vue?vue&type=template&id=78bdf815&scoped=true&"
import script from "./TrocadeSenhaLogin.vue?vue&type=script&lang=js&"
export * from "./TrocadeSenhaLogin.vue?vue&type=script&lang=js&"
import style0 from "./TrocadeSenhaLogin.vue?vue&type=style&index=0&id=78bdf815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bdf815",
  null
  
)

export default component.exports